export default __webpack_public_path__ + "54a73b3706a83770b52dee31470ed7d1.svg";